//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { award, isAward } from '@/api/lottery'
import { getview, relation } from '@/api/jfhl.js'
import { addAnswer, addExchange } from '@/api/chunjie.js'
// import addressInfo from './address-info.vue'
// import { award, addCreditParty, relation, addPartyUser, isAward } from '@/api/zhuanti'
import cjimg from '@/assets/chunjie/fokas/guajiang.png'
export default {
  // components: {
  //   addressInfo
  // },
  data () {
    return {
      zhongjiang: false,
      times: 0,
      cjimg: cjimg,
      // openid: this.$storage.get('openid'),
      show: false,
      context: '',
      isaward: '',
      msg: '',
      lottery: true,
      partyObj: '',
      partyid: '1385',
      partyid2: '1386',
      partyuserid: ''
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  mounted () {
    // this.getPartyuserid()
    // this.viewParty()
    this.view()
  },
  methods: {
    view () {
      getview({
        id: this.partyid
      }).then(res => {
        this.partyObj = res.obj
        this.lotid = res.obj.lotid
        this.init()
        this.getgift()
      })
    },
    getgift () {
      isAward({
        lotid: this.lotid,
        openid: this.accountid
      }).then(data => {
        this.msg = data.obj.item
        if (data.obj.iszhongjiang == 1) {
          // this.$vux.toast.text('今天您已经抽过奖')
          this.zhongjiang = true
          this.showResult()
        }
      })
    },
    goback () {
      console.log('test')
      this.$router.push({ name: 'page_home', params: { id: this.partyid } })
    },
    fillin () {
      this.$router.push({ name: 'chunjie_form' })
    },
    exchange () {
      this.lottery = false
      addExchange({
        openid: this.accountid,
        partyid: this.partyid
        // mobile: this.mobile
        // randnum: this.randnum
      }).then(data => {
        if (data.status == 'suc') {
          this.getLottery()
        }
      })
    },
    getLottery () {
      console.log(this.lotid)
      let _this = this
      // 抽奖
      award({
        lotid: this.lotid,
        // openid: this.openid,
        openid: this.accountid
      }).then(data => {
        if (data.obj.isaward === 2) {
          this.$vux.alert.show({
            content: '您已经兑换福袋',
            buttonText: '回到首页',
            onHide () {
              _this.$router.push({ name: 'page_home', params: { id: _this.partyid } })
            }
          })
        } else {
          relation({
            openid: this.accountid,
            partyuserid: this.partyuserid,
            lotid: this.lotid
          }).then(data => { })
          this.isaward = data.obj.isaward
          this.msg = data.obj.item
          if (this.isaward === 1) {
            this.zhongjiang = true
          }
          if (data.obj.item.indexOf('积分') != -1) {
            this.addJiFen(data.obj.item.replace(/[^0-9]/ig, ''))
          }
        }
      })
    },
    init () {
      let canvas = document.getElementById('mask')
      // let context = canvas.getContext('2d')
      let _this = this
      var img = new Image()
      img.src = cjimg
      img.onload = function () {
        let context = canvas.getContext('2d')
        context.drawImage(img, 0, 0, 270, 162)
        context.globalCompositeOperation = 'destination-out'
        _this.context = context
      }
      // let canvas = document.getElementById('mask')
      // let context = canvas.getContext('2d')
      // context.fillStyle = '#d1d1d1'
      // context.fillRect(0, 0, 300, 120)
      // context.font = '26px arial'
      // context.fillStyle = '#666'
      // context.fillText('刮奖区', 100, 70)
      // context.globalCompositeOperation = 'destination-out'
      // this.context = context
      // 鼠标按下 增加mousemove的事件监听
      canvas.addEventListener('touchstart', this.drawArcMouseHandle)
      canvas.addEventListener('touchsend', event => {
        // 鼠标抬起之后，把mousemove的事件监听撤销掉
        this.removeEventListener('touchmove', this.mousemoveHandle)
      })
      // 监听 touchmove
      canvas.addEventListener('touchmove', this.drawArcTouchHandle)
      this.show = true
    },
    // 根据鼠标的move画圆
    drawArcMouseHandle (event) {
      event.preventDefault()
      event.target.addEventListener('touchmove', this.mousemoveHandle)
    },
    // 为了能够移除movesemove的事件需要单独处理一下
    mousemoveHandle (event) {
      event.preventDefault()
      this.drawArcByPoint(event.pageX, event.pageY)
    },
    // 根据触摸点画圆
    drawArcTouchHandle (event) {
      event.preventDefault()
      var touch = event.touches[0]
      this.drawArcByPoint(touch.pageX, touch.pageY)
    },
    // 根据某个点在canvas上画圆
    // x 坐标和 y 坐标 两个坐标是触摸点的坐标而不是画圆的圆心
    // 圆心通过计算得出
    drawArcByPoint (x, y) {
      this.context.beginPath()
      this.context.arc(
        x - canvas.offsetLeft,
        y - canvas.offsetTop,
        15,
        0,
        Math.PI * 2
      )
      this.context.closePath()
      this.context.fillStyle = '#ffffff'
      this.context.fill()
      this.checkComplete()
    },
    // 判断是否完成刮奖 点数大于80%
    checkComplete () {
      var imgData = this.context.getImageData(0, 0, 270, 162)
      var pxData = imgData.data // 获取字节数据
      var len = pxData.length // 获取字节长度
      var count = 0 // 记录透明点的个数
      // 主要的思想是 一个像素由四个数据组成，每个数据分别是 rgba() 所以第四个数据 a 表示alpha透明度
      for (var i = 0; i < len; i += 4) {
        var alpha = pxData[i + 3] // 获取每个像素的透明度
        if (alpha < 10) {
          // 透明度小于10
          count++
        }
      }
      var percent = count / (len / 4) // 计算百分比
      // 如果百分比大于0.8 则表示成功
      if (percent > 0.5) {
        if (this.lottery) {
          this.exchange()
        }
      }
      if (percent >= 0.6) {
        this.showResult()
      }
    },
    // 显示刮奖结果
    showResult () {
      this.context.clearRect(0, 0, 270, 162)
      if (this.isaward === 1) {
        this.zhongjiang = true
      }
    },
    setZhongjiang (val) {
      this.zhongjiang = val
    }
  }
}
